import { render, staticRenderFns } from "./inventor.vue?vue&type=template&id=634a1f8a&"
import script from "./inventor.vue?vue&type=script&lang=js&"
export * from "./inventor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports